import Button from '@/components/base/Button';

export default function Hero() {
  return (
    <section className="relative w-full min-h-[480px] md:min-h-[600px] flex items-center overflow-hidden bg-[#090909]">
      <div className="absolute inset-0">
        <img
          src="https://storage.helloreaddy.io/project_files/70bd3036-f013-4766-9098-d293cc2afad4/5759bb60-8750-4251-9e44-2a79507b3ef7_compressed_Golden-Garden-Celebration-v2.webp"
          alt="Elegant outdoor evening celebration with well-dressed guests mingling under warm golden light"
          className="w-full h-full object-cover object-top"
        />
      </div>
      {/* Legibility scrim — darkest behind the left-aligned copy, fading across the photo */}
      <div className="absolute inset-0 hero-scrim-left" aria-hidden="true"></div>
      <div className="relative w-full px-4 md:px-8 lg:px-12 pt-28 pb-14 md:pt-36 md:pb-20">
        <div className="max-w-content mx-auto">
          <div className="max-w-3xl">
            <span className="hero-text-shadow font-label text-xs md:text-sm uppercase tracking-widest3 text-primary-400">
              Personally Sourced · Carefully Connected
            </span>
            <h1 className="hero-text-shadow mt-6 font-heading text-4xl md:text-6xl leading-[1.08] text-foreground-950">
              Exceptional events begin with the right connections.
            </h1>
            <p className="hero-text-shadow mt-6 md:mt-8 text-base md:text-lg leading-relaxed text-foreground-900 max-w-2xl">
              Planning something special in London? Tell us what you&rsquo;re looking for, and
              we&rsquo;ll personally source and introduce you to event suppliers who fit your vision,
              needs and budget.
            </p>
            <div className="mt-9 flex flex-col sm:flex-row gap-3 sm:gap-4">
              <Button to="/services" variant="primary" size="lg">
                Find Your Connection
              </Button>
              <Button to="/services" variant="outline" size="lg">
                Explore Our Services
              </Button>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}